var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-maker-container"}},[_c('textarea',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"page-maker-content",attrs:{"id":"page-maker-content"}},[_vm._v(_vm._s(_vm.content))]),_c('div',{staticClass:"page-maker",attrs:{"id":"page-maker"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }